












import { Component, Vue, Prop } from 'vue-property-decorator';
import Sider from 'components/sider.vue';
import { mapState } from 'vuex';
import Header from '@/components/header.vue';
@Component({
    components: {
        Sider,
        Header,
    },
    computed: mapState({ siderData: (state:any) => state.siderData }),
})
export default class Base extends Vue {
    created() {
        const { state } = this.$store;
        if (state.siderData) {
            // 当前页面刷新时重新获取侧边栏
            this.$store.dispatch('GETSIDER', this.$route.meta.type);
        }
    }
}
